import type { RootState } from '@reducers/index';
import { updateUrgent } from '@reducers/search';
import { useViewport } from '@sbt-web/hooks';
import { Button, FormGroup, FormLabel, FullModal, Toggle } from '@sbt-web/ui';
import { urgentLabel } from '@tools/search/values';
import classnames from 'classnames';
import React, { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import NewBadge from '../NewBadge';

import commonClasses from '../SelectorStyles/common.module.scss';
import ownClasses from './urgent.module.scss';
import InfoBadge from '../InfoBadge';
import { FilterURI } from '@sbt-web/network/types';

interface StateProps {
  includeUrgent: boolean;
}

interface OwnProps {
  trackSearchConversion: () => void;
}

interface DispatchProps {
  updateUrgent: (includeUrgent: boolean) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

const UrgentComponent: React.FC<Props> = ({
  includeUrgent,
  updateUrgent,
  trackSearchConversion,
}) => {
  const { isMobile } = useViewport();

  const filterContent = {
    label: 'Urgente',
    text: 'Solo annunci urgenti',
    description:
      'Visualizza gli annunci etichettati come "Urgente" dai venditori che hanno necessità di concludere l\'affare in breve tempo.',
    isNew: false,
  };
  const [isHelpModalOpen, setIsHelpModalOpen] = useState(false);

  const handleSelection = useCallback(
    (isSelected: boolean) => {
      trackSearchConversion();
      return updateUrgent(isSelected);
    },
    [updateUrgent, trackSearchConversion]
  );

  return (
    <FormGroup>
      <div
        className={classnames(
          commonClasses['filler-div'],
          commonClasses['label-with-extra']
        )}
      >
        <FormLabel>{filterContent.label}</FormLabel>

        {!isMobile && (
          <InfoBadge
            onClick={() => setIsHelpModalOpen(true)}
            label={filterContent.label}
          />
        )}

        {isMobile && filterContent.isNew ? <NewBadge /> : null}
        {!isMobile ? (
          <FullModal
            open={isHelpModalOpen}
            title={filterContent.label}
            onClose={() => setIsHelpModalOpen(false)}
            actions={[
              <Button
                key="closer"
                design="solid"
                onClick={() => setIsHelpModalOpen(false)}
              >
                Ok, ho capito
              </Button>,
            ]}
          >
            <p className={ownClasses['modal-max-w']}>
              {filterContent.description}
            </p>
          </FullModal>
        ) : null}
      </div>
      <Toggle
        name={FilterURI.ItemUrgent}
        checked={includeUrgent}
        onInputChange={handleSelection}
        spaceBetweenElements
        classes={[commonClasses['custom-toggle']]}
      >
        {urgentLabel}
      </Toggle>
      {isMobile && (
        <p
          className={classnames(
            'body-text',
            'book',
            'small',
            commonClasses['mobile-help-txt']
          )}
        >
          {filterContent.description}
        </p>
      )}
    </FormGroup>
  );
};

const UrgentSelector = connect<StateProps, DispatchProps, OwnProps, RootState>(
  (state, ownProps) => ({
    includeUrgent: state.search.includeUrgent,
    trackSearchConversion: ownProps.trackSearchConversion,
  }),
  (dispatch) => ({
    updateUrgent: (isActive: boolean) => dispatch(updateUrgent(isActive)),
  })
)(UrgentComponent);

export default UrgentSelector;
export { UrgentComponent };
